<template>
  <div>
    <el-select size="mini" :value="project_ids" collapse-tags @change="onChange" multiple filterable placeholder="请选择项目">
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-button size="mini" @click="all">全选</el-button>
    <el-button size="mini" @click="notAll">不选</el-button>
  </div>
</template>

<script>

export default {
  name: "selectProjects",
  props:{
    projectIds:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return{
      list:[],
      project_ids:[],
    }
  },
  model:{
    prop:"projectIds",
    event:"onChange"
  },
  mounted() {
    this.getProjectList();
  },
  methods:{
    getProjectList(){
      console.log("getProjectList")
      const that=this;
      ERP.getRequest({url:"admin/Project/getProjectList",data:{}},ret=>{
        console.log(ret);
        if(ret.code){
          that.list=ret.data;
        }else {
          that.$message.error("请求异常")
        }
      })
    },
    onChange(project_ids){
      this.project_ids=project_ids;
      this.$emit("onChange",this.project_ids)
    },
    all(){
      this.onChange(this.list.map(ret=>ret.id))
    },
    notAll(){
      this.onChange([])
    }
  },
  watch:{
    projectIds(n){
      this.project_ids=n;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/common/selectProjects.vue